import styled from "styled-components"

export const ProgressBox = styled.div`
  width: 140px;
  height: 140px;
  position: relative;
  color: #fff;
  flex-shrink: 0 !important;
  flex-grow: 0 !important;
  margin-left: auto;
`
export const DailyProgressBox = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 0;
  align-items: center;
  gap: var(--spacing_xxl, 32px);
  color: #fff;

  & > * {
    flex: 1 1 0;
  }
`

export const ProgressCaloriesTitle = styled.h5`
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
  text-transform: capitalize;
  color: var(--Primitive-White_60, rgba(255, 255, 255, 0.6));
  text-align: center;
`
